import {COUNTRIES} from '../constants/AppConstants';
import {COUNTRY_INITIALS} from '../../common/constants/AppConstants';

export const formatCurrency = (price, country = COUNTRY_INITIALS.MEXICO, currencySymbol = '$', decimals = 2) => {
    return `${currencySymbol}${new Intl.NumberFormat(COUNTRIES[country].locale, {
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals
    }).format(price)}`;
};

export const formatStringToCurrency = (value, currencySymbol = '$') => {
    const number = value.toString().split('.');
    return `${currencySymbol}${number[0].split('').reverse().reduce((acc, num, i) =>
        num === '-' ? acc : num + (i && !(i % 3) ? ',' : '') + acc, '')}`;
};